
  export default {
    data(){
      return {
        image: "/Hijau.jpeg"
      }
    }
  }
    
